import {AbstractControl, ValidatorFn} from '@angular/forms';
import {CountryCode, isValidNumber} from 'libphonenumber-js';

export const phoneNumberValidator = (country: CountryCode = 'FR'): ValidatorFn => (
    control: AbstractControl
): {[key: string]: any} | null =>
    !control.value || isValidNumber(control.value, country) ? null : {phoneNumber: {value: control.value}};
